// MOMERY CUSTOM — Printess save/share panel behavior.
(function () {
  // Idempotenz: falls Script aus Versehen doppelt geladen wird
  if (window.__printessSaveShareUiInit) return;
  window.__printessSaveShareUiInit = true;

  const PANEL_ID = 'Printess-SaveShare';
  const BACKDROP_ID = 'Printess-SaveShareBackdrop';
  const COPY_HINT_RESET_MS = 2500;

  // WICHTIG: Falls Printess bei euch eine andere Klasse setzt, hier anpassen
  const EDITOR_OPEN_CLASS = 'printess-editor-open';

  const getPanel = () => document.getElementById(PANEL_ID);
  const getBackdrop = () => document.getElementById(BACKDROP_ID);
  const getCC = () => document.querySelector('.click-capture');

  const isOpen = (panel) => !!panel && panel.classList.contains('active');

  const isEditorOpen = () =>
    document.documentElement.classList.contains(EDITOR_OPEN_CLASS) ||
    document.body.classList.contains(EDITOR_OPEN_CLASS);

  // click-capture vorherigen Inline-Display merken, nicht “blind” überschreiben
  const cc = getCC();
  const ccPrevDisplay = cc ? cc.style.display : null;

  const showCC = () => {
    const c = getCC();
    if (!c) return;
    if (c.style.display === '') c.style.display = 'block';
  };

  const hideCC = () => {
    const c = getCC();
    if (!c) return;
    c.style.display = ccPrevDisplay ?? '';
  };

  // Transition-Dauer (ms) aus computed styles (inkl. delays), max über alle Properties
  const getTransitionMs = (el) => {
    const cs = window.getComputedStyle(el);

    const toMs = (s) => {
      const v = (s || '').trim();
      if (!v) return 0;
      if (v.endsWith('ms')) return parseFloat(v);
      if (v.endsWith('s')) return parseFloat(v) * 1000;
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : 0;
    };

    const durs = (cs.transitionDuration || '').split(',').map(toMs);
    const dels = (cs.transitionDelay || '').split(',').map(toMs);

    const len = Math.max(durs.length, dels.length, 1);
    const durAt = (i) => durs[i] ?? durs[durs.length - 1] ?? 0;
    const delAt = (i) => dels[i] ?? dels[dels.length - 1] ?? 0;

    let max = 0;
    for (let i = 0; i < len; i++) max = Math.max(max, durAt(i) + delAt(i));
    return Math.ceil(max);
  };

  // -------------------------
  // Critical inline styles (damit first-open NICHT flasht und NICHT "weg" bleibt)
  // -------------------------
  const ensurePanelBaseInline = (panel) => {
    if (!panel) return;

    // nie im normalen Flow rendern
    panel.style.position = 'fixed';
    panel.style.top = '0';
    panel.style.right = '0';
    panel.style.height = '100vh';
    panel.style.width = 'min(470px, 92vw)';
    panel.style.background = '#fff';
    panel.style.boxShadow = '-8px 0 24px rgba(0, 0, 0, .12)';
    panel.style.zIndex = '2147483647';
    panel.style.setProperty('display', 'block', 'important');
  };

  const setPanelOpenInline = (panel) => {
    if (!panel) return;

    // OPEN state inline, damit es selbst ohne CSS sichtbar ist
    panel.style.transform = 'translate3d(0, 0, 0)';
    panel.style.opacity = '1';
    panel.style.visibility = 'visible';
    panel.style.pointerEvents = 'auto';
  };

  const setPanelClosedInline = (panel) => {
    if (!panel) return;

    // CLOSED state inline (für den ersten Frame / falls CSS late kommt)
    panel.style.transform = 'translate3d(110%, 0, 0)';
    panel.style.opacity = '0';
    panel.style.visibility = 'hidden';
    panel.style.pointerEvents = 'none';
  };

  const ensureBackdropBaseInline = (b) => {
    if (!b) return;

    b.style.position = 'fixed';
    b.style.inset = '0';
    b.style.background = 'rgba(0, 0, 0, .55)';
    b.style.zIndex = '2147483646';
  };

  const setBackdropOpenInline = (b) => {
    if (!b) return;
    b.style.opacity = '0.55';
    b.style.pointerEvents = 'auto';
  };

  const setBackdropClosedInline = (b) => {
    if (!b) return;
    b.style.opacity = '0';
    b.style.pointerEvents = 'none';
  };
  // -------------------------

  // ---------- Backdrop ----------
  const showBackdrop = () => {
    const b = getBackdrop();
    if (!b) return;

    ensureBackdropBaseInline(b);

    b.hidden = false;
    b.setAttribute('aria-hidden', 'false');

    // Closed -> reflow -> open (damit auch Transition greifen kann, wenn CSS da ist)
    setBackdropClosedInline(b);
    void b.offsetHeight;

    // Klasse für CSS, aber inline ist die Wahrheit
    b.classList.add('is-active');
    setBackdropOpenInline(b);
  };

  const hideBackdrop = () => {
    const b = getBackdrop();
    if (!b) return;

    b.classList.remove('is-active');
    b.setAttribute('aria-hidden', 'true');
    setBackdropClosedInline(b);

    window.setTimeout(() => {
      b.hidden = true;
    }, 200);
  };
  // -----------------------------

  const openPanel = () => {
    const panel = getPanel();
    if (!panel) return;

    ensurePanelBaseInline(panel);

    // Erst CLOSED setzen (damit kein Flash im Flow möglich ist),
    // dann im nächsten Frame OPEN + .active (Animation wenn CSS da ist)
    setPanelClosedInline(panel);

    showBackdrop();

    requestAnimationFrame(() => {
      // CSS-Klasse setzen (für "richtige" Animationen)
      panel.classList.add('active');
      panel.setAttribute('aria-hidden', 'false');

      // Inline OPEN-state, damit es immer sichtbar ist
      setPanelOpenInline(panel);

      document.body.classList.add('open-cc');
      showCC();

      if (typeof panel.focus === 'function') panel.focus();
    });
  };

  const closePanel = () => {
    const panel = getPanel();
    if (!panel || !isOpen(panel)) return;

    panel.classList.remove('active');
    panel.setAttribute('aria-hidden', 'true');

    // Inline sofort schließen (damit auch ohne CSS zuverlässig zu geht)
    setPanelClosedInline(panel);

    hideBackdrop();

    const transitionMs = getTransitionMs(panel);
    const fallbackMs = Math.max(transitionMs + 150, 700);

    let finished = false;
    let timer = null;

    const cleanup = () => {
      if (finished) return;
      finished = true;

      document.body.classList.remove('open-cc');
      hideCC();

      panel.removeEventListener('transitionend', onEnd);
      if (timer) clearTimeout(timer);
    };

    const onEnd = (e) => {
      if (e.target !== panel) return;
      if (e.propertyName !== 'transform' && e.propertyName !== 'opacity') return;
      cleanup();
    };

    panel.addEventListener('transitionend', onEnd);
    timer = setTimeout(cleanup, fallbackMs);
  };

  // --------- FormFieldValues -> Text (Ausrichtung · Größe · Material) ---------
  const normKey = (k) =>
    String(k || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ')
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue');

  const readFormFieldValues = (ffv) => {
    const out = {};
    if (!ffv) return out;

    if (typeof ffv === 'object' && !Array.isArray(ffv)) {
      Object.keys(ffv).forEach((k) => {
        const nk = normKey(k);
        const v = ffv[k];
        if (v !== null && v !== undefined && String(v).trim() !== '') out[nk] = String(v).trim();
      });
      return out;
    }

    if (Array.isArray(ffv)) {
      ffv.forEach((item) => {
        if (!item) return;

        if (Array.isArray(item) && item.length >= 2) {
          const nk = normKey(item[0]);
          const v = item[1];
          if (nk && v !== null && v !== undefined && String(v).trim() !== '') out[nk] = String(v).trim();
          return;
        }

        if (typeof item === 'object') {
          const k =
            item.name ??
            item.key ??
            item.handle ??
            item.id ??
            item.field ??
            item.label ??
            item.title;

          const v =
            item.value ??
            item.val ??
            item.selected ??
            item.text ??
            item.displayValue ??
            item.display ??
            item.labelValue;

          const nk = normKey(k);
          if (nk && v !== null && v !== undefined && String(v).trim() !== '') out[nk] = String(v).trim();
        }
      });
    }

    return out;
  };

  const pickByCandidates = (map, candidates) => {
    for (const c of candidates) {
      const nc = normKey(c);

      if (map[nc]) return map[nc];

      const hitKey = Object.keys(map).find((k) => k.includes(nc));
      if (hitKey) return map[hitKey];
    }
    return '';
  };

  const buildVariantTextFromDetail = (detail) => {
  const variantTitle = detail?.params?.variantTitle;

  if (
    variantTitle &&
    String(variantTitle).trim() !== '' &&
    String(variantTitle).trim().toLowerCase() !== 'default title'
  ) {
    return String(variantTitle)
      .replace(/\s*\/\s*/g, ' · ')
      .trim();
  }

  const ffvRaw = detail?.params?.formFieldValues;
  const map = readFormFieldValues(ffvRaw);

  const orientation = pickByCandidates(map, [
    'ausrichtung',
    'orientation',
    'typefilter',
    'format',
    'richtung',
  ]);

  const size = pickByCandidates(map, [
    'groesse',
    'größe',
    'size',
    'document_size',
    'documentsize',
    'dimension',
    'abmessung',
  ]);

  const material = pickByCandidates(map, [
    'material',
    'papier',
    'paper',
    'finish',
    'oberflaeche',
    'oberfläche',
  ]);

  const parts = [orientation, size, material].filter((x) => String(x || '').trim() !== '');
  return parts.join(' · ');
};
  // --------------------------------------------------------------------------

  // ---- Save message helper (neu) ----
  const setSaveMessage = (panel, { isResave = false } = {}) => {
    if (!panel) return;
    const el = panel.querySelector('#PrintessSaveShareSaveMsg');
    if (!el) return;

    if (isResave) {
      el.innerHTML = `
      <strong>Erneut gespeichert</strong> – 
      der <strong>neue Link</strong> ist jetzt aktiv. 
      Bitte kopiere ihn erneut.
    `;
    } else {
      el.innerHTML = `
      <strong>Gespeichert</strong> – 
      kopiere den Link, um dein Design später wieder aufzurufen.
    `;
    }

    el.hidden = false;
  };
  // ----------------------------------

  // Tracken, ob dieses Panel in dieser Session schon einmal geöffnet wurde
  // (damit wir beim 2. Save "erneut gespeichert" schreiben können)
  let hasOpenedOnce = false;

  const setPanelData = ({ shareUrl, thumbnailUrl, detail }) => {
    const panel = getPanel();
    if (!panel) return;

    const input = panel.querySelector('#PrintessSaveShareUrl');
    const copyBtn = panel.querySelector('#PrintessSaveShareCopy');
    const hint = panel.querySelector('.printess-save-share-hint');

    const mailLink = panel.querySelector('#PrintessSaveShareMail');
    const waLink = panel.querySelector('#PrintessSaveShareWhatsApp');

    const variantTextEl = panel.querySelector('#PrintessSaveShareVariantText');

    const buildMailtoUrl = (url) => {
      const subject = encodeURIComponent('Mein Design-Link');
      const body = encodeURIComponent(`Hier ist der Link zu meinem Design:\n${url}`);
      return `mailto:?subject=${subject}&body=${body}`;
    };

    if (mailLink) mailLink.href = buildMailtoUrl(shareUrl || '');
    if (waLink) {
      const text = encodeURIComponent(`Hier ist der Link zu meinem Design: ${shareUrl || ''}`);
      waLink.href = `https://wa.me/?text=${text}`;
    }

    if (input) {
      input.value = shareUrl || '';
      input.onclick = () => {
        input.focus();
        input.select();
      };
    }

    const previewWrap = panel.querySelector('.printess-save-share-preview');
    const thumbImg = panel.querySelector('.printess-save-share-thumb');

    if (thumbnailUrl && thumbImg && previewWrap) {
      thumbImg.src = thumbnailUrl;
      thumbImg.alt = 'Vorschau deines Designs';
      previewWrap.hidden = false;
    } else if (previewWrap) {
      previewWrap.hidden = true;
    }

    if (variantTextEl) {
      const txt = buildVariantTextFromDetail(detail);
      if (txt) {
        variantTextEl.textContent = txt;
        variantTextEl.hidden = false;
      } else {
        variantTextEl.textContent = '';
        variantTextEl.hidden = true;
      }
    }

    // ✅ Save-Message immer setzen, bevor der User den Link sieht
    setSaveMessage(panel, { isResave: hasOpenedOnce });

    const setHint = (text) => {
      if (!hint) return;
      hint.textContent = text || '';
      if (text) {
        window.clearTimeout(hint.__t);
        hint.__t = window.setTimeout(() => {
          hint.textContent = '';
        }, COPY_HINT_RESET_MS);
      }
    };

    if (copyBtn) {
      const originalLabel = copyBtn.textContent;

      copyBtn.onclick = async () => {
        const val = input ? input.value : '';
        if (!val) return;

        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(val);
          } else {
            if (input) {
              input.focus();
              input.select();
              document.execCommand('copy');
            }
          }

          // Button-Feedback
          copyBtn.textContent = '✓ LINK KOPIERT';
          copyBtn.classList.add('is-copied');

          setTimeout(() => {
            copyBtn.textContent = originalLabel;
            copyBtn.classList.remove('is-copied');
          }, 3000);

        } catch {
          copyBtn.textContent = 'FEHLER';
          setTimeout(() => {
            copyBtn.textContent = originalLabel;
          }, 2000);
        }
      };
    }
  };

  /**
   * Close-Handling:
   * - Backdrop Klick
   * - click-capture (Theme)
   * - Close Button
   * - ESC
   */

  // Backdrop click => close (capture, damit nichts darunter triggert)
  document.addEventListener(
    'click',
    (e) => {
      const panel = getPanel();
      const b = getBackdrop();
      if (!panel || !b || !isOpen(panel)) return;

      if (e.target === b) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        closePanel();
      }
    },
    { capture: true }
  );

  // click-capture: capture-phase blockt Theme handler
  if (cc) {
    cc.addEventListener(
      'click',
      (e) => {
        const panel = getPanel();
        if (!panel || !isOpen(panel)) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        closePanel();
      },
      { capture: true }
    );
  }

  // Close button im Panel: capture-phase blockt side-panel-close handler
  document.addEventListener(
    'click',
    (e) => {
      const panel = getPanel();
      if (!panel || !isOpen(panel)) return;

      const closeBtn = e.target.closest('.side-panel-close');
      if (!closeBtn) return;
      if (!panel.contains(closeBtn)) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      closePanel();
    },
    { capture: true }
  );

  // ESC
  document.addEventListener('keyup', (e) => {
    if (e.code && e.code.toUpperCase() === 'ESCAPE') {
      const panel = getPanel();
      if (panel && isOpen(panel)) closePanel();
    }
  });

  // Open on save
  document.addEventListener('printess:saved', (evt) => {
    const detail = evt.detail || {};
    setPanelData({
      shareUrl: detail.shareUrl,
      thumbnailUrl: detail.thumbnailUrl,
      detail,
    });
    openPanel();

    // nach erstem Öffnen: ab jetzt sind es "erneut gespeichert"
    hasOpenedOnce = true;
  });

  /**
   * Editor close => Panel close
   */
  let lastEditorOpen = isEditorOpen();

  const editorStateObserver = new MutationObserver(() => {
    const nowOpen = isEditorOpen();

    if (lastEditorOpen && !nowOpen) {
      const panel = getPanel();
      if (panel && isOpen(panel)) closePanel();
    }

    lastEditorOpen = nowOpen;
  });

  editorStateObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });
  editorStateObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });

  // Back/forward cache / page restore
  window.addEventListener('pageshow', () => {
    const panel = getPanel();
    if (panel && isOpen(panel) && !isEditorOpen()) closePanel();
  });
})();
